import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import PlayArrow from '@material-ui/icons/PlayCircleOutline';
import parse from 'html-react-parser';
import Dialog from '@material-ui/core/Dialog';
// import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import ReactPlayer from 'react-player/youtube';

import Container from '../../containers/Container';
import Button from '../../components/Button';
import HexaPicto from '../../components/HexaPicto';
import PdfLoader from '../../utils/PdfLoader';
import styles from './styles';
import preview from '../../res/preview.png';
import grille from '../../res/grille.jpg';

class HomeVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dialog: false };
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  openDialog() {
    this.setState({ dialog: true });
  }

  closeDialog() {
    this.setState({ dialog: false });
  }

  renderDialog() {
    const { classes, data } = this.props;
    const { video: block } = data.home;
    const { dialog } = this.state;
    return (
      <Dialog
        maxWidth="xl"
        fullWidth
        scroll="paper"
        open={dialog}
        onClose={this.closeDialog}
        PaperProps={{ square: true, className: classes.dialogPaper }}
      >
        <IconButton key="icon" color="inherit" onClick={this.closeDialog} className={classes.dialogClose}>
          <HexaPicto width={35} height={35} type="cross" color="grey2" />
        </IconButton>
        <DialogContent className={classes.dialogContent}>
          <ReactPlayer url={block.videoUrl} width="100%" height="100%" controls />
        </DialogContent>
      </Dialog>
    );
  }

  render() {
    const { classes, data } = this.props;
    const { video: block } = data.home;
    return (
      <>
        {this.renderDialog()}
        <div className={classes.container} id="home-video">
          <div className={classes.videoContainer} style={{ backgroundImage: `url(${grille})` }}>
            <ButtonBase
              focusRipple
              className={classes.videoButton}
              onClick={this.openDialog}
              style={{ backgroundImage: `url(${preview})` }}
            >
              <PlayArrow fontSize="inherit" />
            </ButtonBase>
          </div>
          <div className={classes.textContainer}>
            <Container maxWidth="sm">
              <div className={classes.p1}>
                <Typography variant="subtitle1" className={classes.p1Text}>
                  {parse(block.p1)}
                </Typography>
                <Typography className={classes.p1Source}>{parse(block.p1Source)}</Typography>
              </div>
              <div className={classes.p2}>
                <Typography className={classes.p2Text}>{parse(block.p2)}</Typography>
                {block.p2List.map((el, idx) => (
                  <Typography key={idx} className={classes.p2Li}>
                    <span className={classes.p2Puce}>{idx + 1}.</span> {parse(el)}
                  </Typography>
                ))}
              </div>
              <div className={classes.p3}>
                <Typography className={classes.p3Text}>{parse(block.p3)}</Typography>
              </div>
              <Button onClick={PdfLoader(block.pdf)} color="yellow">
                {parse(block.button)}
              </Button>
            </Container>
          </div>
        </div>
      </>
    );
  }
}

HomeVideo.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomeVideo);
